// extracted by mini-css-extract-plugin
module.exports = {"forum":"forum--2vkTR","forum_list":"forum_list--2LJU4","loading":"loading--7g-Ik"};